import React, { useEffect, useRef, useState } from 'react';

// Lightweight IntersectionObserver fade-up wrapper
const Reveal = ({ children, as: Tag = 'div', className = '', delay = 0, ...rest }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => setVisible(true), delay);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`fade-up ${visible ? 'visible' : ''} ${className}`} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
